import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ChatBubbleBottomCenterTextIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/chat-bubble-bottom-center-text"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M12 2.3999C9.31684 2.3999 6.68327 2.61476 4.11566 3.02839C2.39202 3.30606 1.19995 4.8158 1.19995 6.51096V12.6888C1.19995 14.384 2.39201 15.8937 4.11566 16.1714C5.51712 16.3972 6.93827 16.5637 8.37643 16.6685C8.71208 16.6929 9.00139 16.8842 9.14692 17.1641L11.2015 21.1151C11.3564 21.413 11.6642 21.5999 12 21.5999C12.3357 21.5999 12.6435 21.413 12.7984 21.1151L14.853 17.1641C14.9985 16.8842 15.2878 16.6929 15.6235 16.6685C17.0616 16.5637 18.4828 16.3972 19.8842 16.1714C21.6079 15.8937 22.8 14.384 22.8 12.6888V6.51096C22.8 4.8158 21.6079 3.30606 19.8842 3.02839C17.3166 2.61476 14.6831 2.3999 12 2.3999ZM8.09995 7.1999C7.60289 7.1999 7.19995 7.60285 7.19995 8.0999C7.19995 8.59696 7.60289 8.9999 8.09995 8.9999H15.9C16.397 8.9999 16.8 8.59696 16.8 8.0999C16.8 7.60285 16.397 7.1999 15.9 7.1999H8.09995ZM8.09995 10.1999C7.60289 10.1999 7.19995 10.6028 7.19995 11.0999C7.19995 11.597 7.60289 11.9999 8.09995 11.9999H12.3C12.797 11.9999 13.2 11.597 13.2 11.0999C13.2 10.6028 12.797 10.1999 12.3 10.1999H8.09995Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ChatBubbleBottomCenterTextIcon;